import {
    Box,
    Button,
    Heading,
    Input,
    Menu,
    MenuButton,
    MenuItem,
    MenuList
} from '@chakra-ui/react'
import { Icon } from 'components/atoms'
import { useAuthContext } from 'contexts/auth'
import { useInstitutionsContext } from 'contexts/institutions'
import { useCacheFilters } from 'hooks/useCacheFilters'
import { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import InstitutionsService from 'services/institutions'
import { agentAll } from 'utils/fakeValues'
import { saveToSessionStorage } from 'utils/sessionStorage'
import { useDebounce } from 'utils/useDebounce'

export const AgentAutocomplete = () => {
    const { isBackoffice } = useAuthContext()
    const {
        currentInstitution,
        setCurrentAgent,
        currentAgent,
        setAgents,
        agents
    } = useInstitutionsContext()

    const { getCacheFilters } = useCacheFilters()
    const { pathname } = useLocation()

    const [loading, setLoading] = useState(true)
    const pathNameFormatterd = '/' + pathname.split('/')[1]
    const href = window.location.href
    const setAgent = () => {
        const cacheFilters = getCacheFilters()
        if (cacheFilters?.currentAgent) {
            setCurrentAgent(cacheFilters?.currentAgent)
            return
        }

        setCurrentAgent(agentAll)
    }

    useEffect(() => {
        if (
            pathNameFormatterd.includes('/relatorio') &&
            currentInstitution?.id
        ) {
            fetchAgents()
        }
    }, [pathNameFormatterd, currentInstitution?.id])

    useEffect(() => {
        setAgent()
    }, [currentInstitution?.id])

    useEffect(() => {
        saveToSessionStorage('agent', currentAgent)
    }, [currentAgent])

    const visibleForHeader =
        pathNameFormatterd.includes('/relatorio') &&
        pathNameFormatterd !== '/relatorio-gestao' &&
        currentInstitution?.id

    const handleSelectIf = useCallback(
        (isOpen: boolean) => {
            if (agents?.length) {
                return <Icon name={isOpen ? 'chevron-up' : 'chevron-down'} />
            }
        },
        [isBackoffice, agents]
    )

    useEffect(() => {
        setAgent()
    }, [pathNameFormatterd])

    const handleUserType = () => {
        if (currentAgent && currentAgent.razaoSocial) {
            return currentAgent.razaoSocial
        } else {
            return 'Todos'
        }
    }

    const fetchAgents = async (razaoSocial?: string) => {
        if (href.includes('/relatorio?')) {
            setLoading(false)
            return
        }

        setLoading(true)

        const query = {
            pagina: 1,
            limite: 100
        }

        const institutionId = currentInstitution?.id || ''
        const requestData = razaoSocial
            ? { razaoSocial, ...query }
            : { ...query }

        try {
            const response = await InstitutionsService.getInstitutionAgent(
                institutionId,
                requestData
            )
            const agents = [agentAll, ...response.data]
            setAgents(agents)
        } finally {
            setLoading(false)
        }
    }

    const handleInputChange = useDebounce(
        (e: ChangeEvent<HTMLInputElement>) => {
            const razaoSocial = e.target.value.toLowerCase().trim()
            if (razaoSocial) {
                fetchAgents(razaoSocial)
            }
        }
    )

    const inputRef = useRef<any>(null)

    const clearInput = () => {
        if (inputRef.current) {
            inputRef.current.value = ''
        }
        fetchAgents()
    }

    return (
        <>
            {visibleForHeader && (
                <Menu data-testid="header-perfil-menu">
                    {({ isOpen }) => (
                        <>
                            <MenuButton
                                data-testid="header-perfil-button"
                                size="md"
                                colorScheme="white"
                                color="inherit"
                                shadow="md"
                                w={{ base: 'full', lg: 'auto' }}
                                as={Button}
                                rightIcon={handleSelectIf(isOpen)}
                                isActive={isOpen}
                                isLoading={loading}
                                isDisabled={!currentInstitution?.id}
                            >
                                {handleUserType()}
                            </MenuButton>
                            {agents?.length ? (
                                <MenuList
                                    data-testid="header-perfil-list"
                                    zIndex="dropdown"
                                >
                                    <Box px="4">
                                        <Box textAlign="center" mt="8">
                                            <Heading
                                                as="h2"
                                                size="md"
                                                fontWeight="bold"
                                            >
                                                Selecionar Agente Financeiro
                                            </Heading>

                                            <Input
                                                mb="4"
                                                placeholder="Buscar pelo nome"
                                                variant="flushed"
                                                onChange={handleInputChange}
                                                ref={inputRef}
                                            />
                                        </Box>
                                        <Box overflowY="auto" maxHeight="300px">
                                            {agents.map((agent, key) => (
                                                <MenuItem
                                                    data-testid={`header-perfil-item-${key}`}
                                                    key={key}
                                                    onClick={() => {
                                                        setCurrentAgent(agent)
                                                        clearInput()
                                                    }}
                                                >
                                                    {agent.razaoSocial}
                                                </MenuItem>
                                            ))}
                                        </Box>
                                    </Box>
                                </MenuList>
                            ) : (
                                <MenuList
                                    data-testid="header-perfil-list"
                                    zIndex="dropdown"
                                >
                                    <Box px="4">
                                        <Box textAlign="center" mt="8">
                                            <Heading
                                                as="h2"
                                                size="md"
                                                fontWeight="bold"
                                            >
                                                Selecionar Agente Financeiro
                                            </Heading>

                                            <Input
                                                mb="4"
                                                placeholder="Buscar pelo nome"
                                                variant="flushed"
                                                onChange={handleInputChange}
                                            />
                                        </Box>
                                        <MenuItem isDisabled>
                                            Nenhum item encontrado.
                                        </MenuItem>
                                    </Box>
                                </MenuList>
                            )}
                        </>
                    )}
                </Menu>
            )}
        </>
    )
}